module.exports = __webpack_public_path__ + "static/img/5646_phase_function_Paper_PointsHejduk_Prediction.d7e06f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5646_phase_function_Paper_PointsHejduk_Prediction.png
// module id = XQl2
// module chunks = 0